import { GenericApi } from "./generic.api";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
	IShippingDetails,
	ShippingDetails,
	ShippingDetailsClass,
	TAutoCompleteRes,
	TPlaceDetailsRes,
} from "../model/shippingDetail.model";
import { Observable } from "rxjs";
import { createUrl, queryToParams } from "./api.util";
import { IQueryFilter } from "../model/query.filter.class";

// Convenience Type
type T = IShippingDetails;

@Injectable({ providedIn: 'root' })
export class ShippingDetailApi extends GenericApi<T> {
	public path = "shipping_details";

	constructor(public httpClient: HttpClient) {
		super(httpClient);
	}

	public readonly getShippingDetailsList = (
		customerId: string | number
	): Observable<ShippingDetailsClass[]> => {
		return this.httpClient.get<ShippingDetailsClass[]>(
			createUrl("customer", customerId, "address")
		);
	};

	public readonly deleteAddress = (
		id: number,
		customerId: number
	): Observable<{ success: boolean; deleted: number }> => {
		return this.httpClient.delete<{ success: boolean; deleted: number }>(
			createUrl(this.path, id),
			{
				params: {
					customerId: String(customerId),
				},
			}
		);
	};

	readonly restore = (id: number | string): Observable<{ success: boolean }> =>
		this.httpClient.get<{ success: boolean }>(
			createUrl(this.path, id, "restore"),
			{}
		);

	readonly autoComplete = (address: string): Observable<TAutoCompleteRes[]> =>
		this.httpClient.post<TAutoCompleteRes[]>(
			createUrl(this.path, "autocomplete"),
			{
				address
			}
		);

	readonly validateText = (address: string): Observable<{ isValid: boolean }> =>
		this.httpClient.post<{ isValid: boolean }>(
			createUrl(this.path, "validate-address"),
			{
				address
			}
		);

	readonly getPlaceDetail = (placeId: string): Observable<TPlaceDetailsRes> =>
		this.httpClient.post<TPlaceDetailsRes>(
			createUrl(this.path, "place-detail"),
			{
				placeId
			}
		);
}
